import { X } from "lucide-react";
import { type ReactNode, useEffect } from "react";

type Props = {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
};

export function BottomSheet({ open, onClose, title, children }: Props) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center">
      <button
        type="button"
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
        aria-label="閉じる"
      />
      <div
        className="relative flex max-h-[88dvh] w-full max-w-lg flex-col rounded-t-[28px] border border-b-0 border-[#e3e8f0] bg-white px-4 pt-3 shadow-2xl animate-slide-up sm:px-5"
        style={{
          paddingBottom: "max(1rem, env(safe-area-inset-bottom, 1rem))",
        }}
      >
        <div className="mx-auto mb-2 h-1 w-10 rounded-full bg-gray-200" />
        <div className="mb-3 flex min-h-11 items-center justify-between">
          {title && (
            <h3 className="text-lg font-extrabold text-gray-900">{title}</h3>
          )}
          <button
            type="button"
            onClick={onClose}
            className="ml-auto flex h-11 w-11 items-center justify-center rounded-[10px] text-gray-500 hover:bg-[#f0f3f8]"
          >
            <X size={20} />
          </button>
        </div>
        <div className="min-h-0 overflow-y-auto pb-2">{children}</div>
      </div>
    </div>
  );
}
